// extracted by mini-css-extract-plugin
export var addToCartButton = "_n1-b";
export var arrowButtonContainer = "_n1-9";
export var arrowButtonIcon = "_n1-a";
export var carouselArrowButton = "_n1-6";
export var carouselElementContainer = "_n1-1";
export var left = "_n1-7";
export var productDisplayCarouselContainer = "_n1-0";
export var productTileContainer = "_n1-2";
export var productTileImage = "_n1-4";
export var productTileImageContainer = "_n1-3";
export var productTileTitle = "_n1-5";
export var right = "_n1-8";
export var sliderOverflow = "_n1-c";